import Helper from '@lovata/popup-helper';

export default new class headerAccount {
  constructor() {
    this.drawerBtnSelector = 'js-header-account';
    this.panelSelector = 'header-account-info__panel';
    this.panelOpenSelector = 'header-account-info__panel_visible';
    this.drawerParentSelector = 'header';
    this.drawerCloseSelector = 'header-account-mini-panel__close';

    this.handler();
  }

  handler() {
    $(document).on('click', `.${this.drawerBtnSelector}`, () => {
      const panel = $(`.${this.panelSelector}`);
      const isOpen = panel.hasClass(this.panelOpenSelector);
      const closeBtnNode = document.querySelector(`.${this.drawerCloseSelector}`);
      Helper.setBodyScrollState(isOpen);
      Helper.overlayController(!isOpen);

      panel.toggleClass(this.panelOpenSelector);
      Helper.overlayHandler(!isOpen, closeBtnNode, panel[0]);

      setTimeout(() => {
        Helper.focusTrapManager(!isOpen, panel[0]);
      }, 300);
    });
  }
}();
